import { z } from "zod";
import apiClient from "../../../shared/api/client";
import type { NewsletterStats, PaginationParams, Subscription, SubscriptionList } from "../types";

const subscriptionSchema = z.object({
  id: z.string(),
  email: z.string(),
  status: z.enum(["active", "unsubscribed"]),
  source: z.enum(["public_form", "manual_admin", "import", "signup"]),
  subscribedAt: z.string(),
  unsubscribedAt: z.string().nullable().optional(),
  metadata: z.record(z.unknown()).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

const subscriptionsListSchema = z.object({
  data: z.array(subscriptionSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
  totalPages: z.number(),
});

const newsletterStatsSchema = z.object({
  total: z.number(),
  active: z.number(),
  unsubscribed: z.number(),
  newThisWeek: z.number(),
  retentionRate: z.number(),
});

export const getSubscriptions = async (params?: PaginationParams): Promise<SubscriptionList> => {
  const response = await apiClient.get("/admin/newsletter/subscriptions", { params });
  const parsed = subscriptionsListSchema.parse(response.data);
  return parsed;
};

export const addSubscription = async (email: string): Promise<Subscription> => {
  const response = await apiClient.post("/admin/newsletter/subscriptions", { email });
  const parsed = subscriptionSchema.parse(response.data);
  return parsed;
};

export type StatsPeriod = "day" | "week" | "month" | "all";

export const getStats = async (period?: StatsPeriod): Promise<NewsletterStats> => {
  const response = await apiClient.get("/admin/newsletter/stats", {
    params: period ? { period } : undefined,
  });
  const parsed = newsletterStatsSchema.parse(response.data);
  return parsed;
};

export const deleteSubscription = async (id: string): Promise<void> => {
  await apiClient.delete(`/admin/newsletter/subscriptions/${id}`);
};

export const newsletterApi = {
  getSubscriptions,
  addSubscription,
  getStats,
  deleteSubscription,
};
